import { useNavigate } from '@solidjs/router'
import { chatStore, userStore } from '/web/store'
import { isLoggedIn } from '/web/store/api'

export const getOrCreateChatWithCharacter = (
  characterId: string,
  onSuccess: (url: string) => void
) => {
  console.log('getOrCreateChat', characterId)
  // const nav = useNavigate()
  if (isLoggedIn()) {
    const chatWithChar = chatStore().allChats.find((chat) => chat.characterId === characterId)

    if (chatWithChar) {
      onSuccess(`/chat/${chatWithChar._id}`)
    } else {
      const payload = {
        characterId: characterId,
        genPreset: 'e9659b15-63d1-4091-8e8a-80e65909c2ad',
        mode: 'standard',
        schema: 'text',
        name: '',
        useOverrides: false,
        imageSource: 'main-character',
      }
      chatStore.createChat(characterId, payload, (id: string) => onSuccess(`/chat/${id}`))
    }
  } else {
    userStore.loginModal(true)
  }
}
